import { themeWorkspace } from "../theme-node";
import * as Blockly from "blockly";

Blockly.defineBlocksWithJsonArray([
  {
    type: "test_field_multilinetext",
    message0: "multilineinput: %1",
    args0: [
      {
        type: "field_multilinetext",
        name: "FIELDNAME",
        text: "some text \n with newlines",
      },
    ],
  },
]);

export function init() {
  return {
    kind: "category",
    name_universal: "experimental",
    name: "Experimental",
    colour: themeWorkspace.categoryStyles.feedback_category.colour,
    imageName: "/toolbox-imgs/random-solid.svg",
    id: "4",
    contents: [
      {
        kind: "block",
        type: "context_question",
        fields: {
          question_variable: {
            name: "question",
            type: "QUESTION",
          },
        },
      },
      {
        kind: "block",
        type: "display_element",

        inputs: {
          object: {
            block: {
              type: "text",
              fields: { TEXT: "1" },
            },
          },
        },
        next: {
          block: {
            type: "display_element",
            inputs: {
              object: {
                block: {
                  type: "text",
                  fields: { TEXT: "2" },
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "text_multiline",
      },
    ],
  };
}
